import React, { useEffect, useMemo, useState } from "react";
import {
  Layout,
  Card,
  Button,
  Input,
  Radio,
  Popconfirm,
  Form,
  InputNumber,
  message,
  Select,
} from "antd";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useSelector } from "react-redux";
import CustomThemeDrawer from "../../../../../Elements/CustomThemeDrawer";
import {
  EditOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { APIConstants } from "../../../../../../Common/APIConstants";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";

const DashLive = () => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [refetch2, setRefetch2] = useState(false);
  const [refetch3, setRefetch3] = useState(false);
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    // form1.resetFields()
    setOpen(false);
  };
  const showDrawer2 = () => {
    setOpen2(true);
  };

  const onClose2 = () => {
    // form2.resetFields()
    setOpen2(false);
  };
  const showDrawer3 = () => {
    setOpen3(true);
  };

  const onClose3 = () => {
    setOpen3(false);
  };
  const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  //console.log(color);
  const { isdarkMode } = mode;

  const [externalEnergySources, setExternalEnergySources] = useState([]);
  const [updateExternalEnergySources, setUpdateExternalEnergySources] =
    useState([]);
  const [productionData, setProductionData] = useState([]);
  const [resourceDetails, setResourceDetails] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    meterID: 0,
    converterID: 0,
  });
  const [selectedSubGroupValue, setSelectedSubGroupValue] = useState("");
  const [groupData, setGroupData] = useState([]);
  const [mainDashboardData, setMainDashboardData] = useState([]);
  const [parameterMetersValue, setParameterMetersValue] = useState([]);
  const [deviceData, setDeviceData] = useState([]);
  const [groupname, setGroupname] = useState([]);
  const [subGroup, setSubGroup] = useState([]);
  const [groupID, setGroupId] = useState();
  const [consumptionDetail, setConsumptionDetails] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState(
    []
  );
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]);
  const [metersData, setMetersData] = useState([]);
  const [selectedConverter, setSelectedConverter] = useState();
  const [selectedConverterID, setSelectedConverterID] = useState();
  const [parameterConfigAutoID, setParameterConfigAutoID] = useState(null);
  const [selectedMeters, setSelectedMeters] = useState();
  const [parameter, setParameter] = useState([]);
  const [dataType, setDataType] = useState([]);

  useEffect(() => {
    getGroup();
  }, [refetch]);

  // Meters
  useEffect(() => {
    if (selectedConverterID) {
      makeRequest({
        type: APIConstants.GET,
        // GetFlowSteamGropeMeterDetails?GroupID=81
        url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${selectedConverterID}`,
      }).then((res) => {
        //console.log(res);
        if (res && res.length > 0) {
          setMetersData(res);
        } else {
          setMetersData([]);
        }
      });
    }
  }, [selectedConverterID]);
  // converters
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`,
    }).then((res) => {
      // //console.log(res);
      if (res && res.length > 0) {
        setGroupData(res);
      }
    });
  }, []);
  // parameters
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        setParameter(res);
      }
    });
  }, []);
  // data type
  useEffect(() => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.ELECTRICAL_DATA_TYPE_DETAILS}`,
    }).then((res) => {
      //console.log(res);
      if (res && res.length > 0) {
        setDataType(res);
      }
    });
  }, []);

  const handleNotification = (msg, type) => {
    message.open({
      content: `${msg}`,
      type: type,
    });
  };

  const getGroup = () => {
    // http://20.244.40.160:92/getGroupDetails?ConverterName=as&ConverterID=1
    const url = `${APIConstants.ELECTRICAL_GET_DASHBOARD_METER_DETAILS}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.GET,
      url: url,
      // body:formValues
    }).then((res) => {
      //console.log(res);
      if (res) {
        setMainDashboardData(res);
      }
    });
  };
  function replaceDataType(parameters, dataTypeMap) {
    return parameters.map((param) => {
      const match = dataTypeMap.find(
        (m) => m.parameterId == param.parameterDataType
      );
      return {
        ...param,
        parameterDataType: match
          ? match.parameterDataType
          : param.parameterDataType,
      };
    });
  }
  const getSubGroup = () => {
    //console.log(selectedValue);
    if (selectedValue && selectedValue.meterID && selectedValue.converterID) {
      const url = `${APIConstants.ELECTRICAL_GET_PARAMETER_CONFIG_DETAILS}?ConverterID=${selectedValue.converterID}&MeterID=${selectedValue.meterID}`;
      // const url = `${APIConstants.DEVICE_DETAILS}`;
      //console.log(url);
      makeRequest({
        type: APIConstants.GET,
        url: url,
        // body:formValues
      }).then((res) => {
        //console.log(res);
        if (res) {
          const updatedParameters = replaceDataType(res, dataType);
          //console.log(updatedParameters);
          setParameterMetersValue(updatedParameters);
        }
      });
    }
  };
  const getDevices = (values) => {
    //console.log("Form values:", values);

    if (values) {
      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.ELCTRICAL_SUBGROUP_METER_DETAILS}?SubGroupID=${values}`,
      })
        .then((res) => {
          //console.log("Meter Details:", res);
          if (res && res.length > 0) {
            //  setShowGrid(true);
            setDeviceData(res);
          }
        })
        .catch((err) => {
          //console.error("Error fetching meter details", err);
        });
    } else {
      //console.error("Something went wrong");
    }
  };
  useEffect(() => {
    //console.log(selectedSubGroupValue);
    getDevices(selectedSubGroupValue);
  }, [selectedSubGroupValue]);

  useEffect(() => {
    getSubGroup();
  }, []);
  useEffect(() => {
    getSubGroup();
  }, [selectedValue, refetch]);
  // useEffect(() => {
  //   makeRequest({
  //     type: APIConstants.GET,
  //     url: `${APIConstants.GET_EXTERNAL_ENERGY_SOURCE}`,
  //   }).then((res) => {
  //     //console.log(res);
  //     function addIsUpdateFlag(sourceArray) {
  //       return sourceArray.map((item) => ({
  //         ...item,
  //         // isUpdate: false,
  //       }));
  //     }

  //     if (res && res.length > 0) {
  //       const updatedSources = addIsUpdateFlag(res); // originalSources is your input array
  //       //console.log(updatedSources);

  //       setExternalEnergySources(updatedSources);
  //       setUpdateExternalEnergySources(updatedSources);
  //     }
  //   });
  // }, [refetch]);
  // useEffect(() => {
  //   getSubGroup();
  // }, [refetch2]);

  const deviceCols = [
    { headerName: "S.No", field: "parameterConfigAutoID", width: 80 },
    { headerName: "Parameter Name", field: "parameterName", flex: 1 },
    { headerName: "Title", field: "parameterHeading", flex: 1 },
    { headerName: "Data  Type", field: "parameterDataType", flex: 1 },
    { headerName: "Target Value ", field: "targetValue", flex: 1 },
    { headerName: "Low Threshold Value", field: "lowThreshold", flex: 1 },
    { headerName: "High Threshold Value", field: "highThreshold", flex: 1 },

    {
      headerName: "Actions",
      width: 150,
      cellRenderer: (params) => (
        <div className="space-x-4">
          <span
            className="text-green-500 bg-green-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-green-400"
            onClick={() => {
              //console.log(params.data);
              handleUpdate(params.data);
              // handleParameterUpdate(params.data)
            }}
          >
            <EditOutlined />
          </span>
          <Popconfirm
            title="Are you sure to delete ?"
            icon={<QuestionCircleOutlined style={{ color: "red" }} />}
            onConfirm={() => deleteParameter(params.data)}
            trigger="click"
          >
            <span
              className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400"
            >
              <DeleteOutlined />
            </span>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const groupCols = [
    {
      headerName: "",
      field: "select",
      width: 30,
      headerCheckboxSelection: false, // optional
      cellRenderer: (params) => {
        return (
          <input
            type="checkbox" // Change to "checkbox" if you prefer
            name="rowSelect"
            defaultChecked={
              params.data.meterID === selectedValue.meterID &&
              params.data.converterID === selectedValue.converterID
            }
            onChange={(e) => {
              if (e.target.checked) {
                //console.log("Selected Row:", params.data);
                setSelectedValue({
                  meterID: params.data.meterID,
                  converterID: params.data.converterID,
                });
              } else {
                //console.log("Unchecked Row:", params.data);
                setSelectedValue({})
                setParameterMetersValue([])
              }
            }}
          />
        );
      },
    },
    // { headerName: " ID", field: "groupID", width: 100 },
    { headerName: "Metername", field: "meterName", width: 110, flex: 1 },
    {
      headerName: "Actions",
      width: 80,
      flex: 1,
      cellRenderer: (params) => {
        return (
          <div className="space-x-2">
            {/* <Button
              //   onClick={() => {
              //     params.data.actions.update(params.data);
              //   }}
              >
                <EditOutlined />
              </Button> */}

            <Popconfirm
              title="Are you sure to delete ?"
              // description="Are you sure to delete this Converter Configuration?"
              icon={<QuestionCircleOutlined style={{ color: "red" }} />}
              onConfirm={() => deleteGroup(params.data)}
              trigger="click"
            >
              <span
                className="text-red-500 bg-red-200 p-2 cursor-pointer shadow-lg rounded-md px-4 
             transition-transform duration-200 hover:border-[1px] border-red-400"
              >
                <DeleteOutlined />
              </span>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const onFinish2 = (values) => {
    //   setFormValues(values);
    form2.resetFields();

    //console.log(values); // Log the form values
    //   handleOk();
    insertGroup(values);
  };

  const insertGroup = (formValues) => {
    //console.log(formValues);
    //console.log(selectedConverter);
    const updatedData = mainDashboardData.find(
      (meter) => meter.meterID === formValues.meterID
    );
    //console.log(updatedData);
    const body = (values) => {
      return {
        // ...values,
        meterAutoID: selectedConverter.autoID || 0,
        converterID: selectedConverter.converterID || 0,
        meterID: selectedConverter.meterID || 0,
        parameterID: values.parameterID || 0,
        targetValue: values.targetValue,
        lowThresholdValue: values.lowThresholdValue || 0,
        highThreshold: values.highThresholdValue || 0,
        parameterHeading: values.parameterHeading || 0,
        parameterDataType: values.parameterDataType || 0,
      };
    };
    //console.log(dataType.find((i)=>i.parameterDataType==formValues?.parameterDataType))
    const body2 = (values) => {
      return {
        // ...values,
        parameterConfigAutoID: parameterConfigAutoID,
        converterID: updatedData.converterID || 0,
        meterID: values.meterID || 0,
        targetValue: values.targetValue || 0,
        lowThresholdValue: values.lowThresholdValue || 0,
        highThreshold: values.highThresholdValue || 0,
         parameterDataType: dataType.find((i)=>i.parameterDataType==values.parameterDataType)?.parameterId || values.parameterDataType,
        parameterHeading: values.parameterHeading || 0,
      };
    };
    const url = `${APIConstants.ELECTRICAL_UPDATE_PARAMETER_CONFIG_DETAILS}`;
    const url2 = `${APIConstants.ELECTRICAL_POST_PARAMETER_CONFIG_DETAILS}`;
    //console.log(url);
    //console.log(body(formValues));
    //console.log(body2(formValues));
    // //console.log(values);

    makeRequest({
      type: APIConstants.POST,
      url: isUpdate ? url : url2,
      body: isUpdate ? body2(formValues) : body(formValues),
    }).then((res) => {
      setRefetch(!refetch);
      onClose2();
      setIsUpdate(false);
      // handleNotification("Successfully added!", "success");
      console.log(res); 
       handleNotification(res?.message, res?.message.includes('Successfully')? "success":"error");
    });
  };
  const deleteGroup = (formValues) => {
    //console.log(formValues);

    const body = {
      groupID: formValues.groupID,
    };

    const url = `${APIConstants.ELECTRICAL_DELETE_DASHBOARD_METER_DETAILS}?AutoID=${formValues.autoID}`;

    //console.log(url);
    //console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {
      //console.log(res);
      // onClose2();
      setRefetch(!refetch);
      handleNotification(res.message, "success");
    });
  };

  const handleUpdate = (values) => {
    //console.log(values);
    setParameterConfigAutoID(values.parameterConfigAutoID);
    setSelectedConverter(values.converterID);
    //console.log(mainDashboardData);
    const meter = mainDashboardData.find((i) => i.meterID == values.meterID);
    //console.log(meter?.meterName);
    const record = {
      ...values,
      // meterID:meter.metername,
      lowThresholdValue: values.lowThreshold,
      highThresholdValue: values.highThreshold,
      parameterDataType: values.parameterDataType,
    };
    setIsUpdate(true);
    //console.log(record);
    form2.setFieldsValue(record);
    showDrawer2();
  };

  const handleParameterUpdate = (formValues) => {
    //console.log(formValues);
    const url = `${APIConstants.ELECTRICAL_UPDATE_PARAMETER_CONFIG_DETAILS}`;
    //console.log(url);

    makeRequest({
      type: APIConstants.POST,
      url: url,
      body: formValues,
    })
      .then((res) => {
        //console.log(res);
        // setRefetch3(!refetch3)

        handleNotification("Sub Group added successfully!", "success");
      })
      .catch((err) => {
        handleNotification("Something went wrong!", "error");
      });
  };
  const deleteParameter = (formValues) => {
    //console.log(formValues);
    // setSelectedValue(formValues.groupID)

    const body = {
      parameterConfigAutoID: formValues.parameterConfigAutoID,
      meterID: formValues.meterID,
      converterID: formValues.converterID,
    };

    const url = `${APIConstants.ELECTRICAL_DELETE_PARAMETER_CONFIG_DETAILS}`;

    //console.log(url);
    //console.log(body);

    makeRequest({
      type: APIConstants.DELETE,
      url: url,
      body: body,
    }).then((res) => {
      //console.log(res);
      setRefetch2(!refetch2);
      setRefetch(!refetch);
      handleNotification(res.message, "success");
    });
  };
  const onFinish1 = (values) => {
    //console.log(values);

    const transformedData = {
      converterID: values?.converterID?.key,
      meterName: values.meterID?.value,
      meterID: values.meterID.key,
    };

    //console.log("Transformed Data to Submit:", transformedData);

    makeRequest({
      type: APIConstants.POST,
      url: `${APIConstants.ELECTRICAL_DASHBOARD_METER_DETAILS}`,
      body: transformedData,
    })
      .then((res) => {
        //console.log("API Response:", res);
        //console.log("Transformed Data:", transformedData);
        message.success("Group Config saved successfully!");

        onClose();
        form1.resetFields();
        setRefetch(!refetch);
      })
      .catch((error) => {
        //console.error("Error saving Group Config:", error);
      });
  };

  //console.log(externalEnergySources);

  //console.log(productionData);
  //console.log(resourceDetails);
  const handleMeterChange = (selectedKeys) => {
    const selectedMeters = selectedKeys
      .map((selectedKey) => {
        const meter = nsGetFlowConverterResData.find(
          (meter) => meter.meterid === selectedKey
        );
        return meter
          ? { meterId: meter.meterid, meterName: meter.metername }
          : null;
      })
      .filter(Boolean);

    setSelectedMeterIds(selectedMeters);
  };
  useEffect(() => {
    setDeviceData([]);
    setSelectedSubGroupValue("");
  }, [selectedValue]);
  const handleConverterChange = (value) => {
    //console.log(value);
    const selectedMeterId = value; // because labelInValue is used
    // setSelectedConverter(value); // or setSelectedConverter(selectedMeterId) based on your state

    // If you have a status state or data model, update it here
    const updatedData = mainDashboardData.find(
      (meter) => meter.meterID === selectedMeterId
    );
    //console.log(updatedData);
    // setMainDashboardData(updatedData);
    setSelectedConverter(updatedData);
  };
  const handleConverter = (value) => {
    //console.log(value);

    setSelectedConverterID(value?.key);
  };
  return (
    <div
      className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}
    >
      <div>
        <h2
          className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
            isdarkMode ? "text-white" : "text-black"
          }`}
        >
          Dash Live
        </h2>

        <div className="flex gap-4 h-[90vh]">
          {/*  Main Dashbboard Configuration */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Main Dashbboard Configuration
              </span>
            }
            extra={
              <Button type="primary" onClick={() => showDrawer()}>
                Add +
              </Button>
            }
            className={`w-1/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={mainDashboardData}
                columnDefs={groupCols}
                domLayout="normal"
              />
            </div>
          </Card>

          {/* External Energy Sources */}
          {/* {deviceData.length > 0 && ( */}
          <Card
            title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Parameter for Meter
              </span>
            }
            extra={
              <Button
                type="primary"
                onClick={() => {
                  showDrawer2();
                  setIsUpdate(false);
                  form2.resetFields();
                }}
              >
                Add +
              </Button>
            }
            className={`w-2/3 rounded-md overflow-hidden shadow ${isdarkMode ? "bg-transparent" : "bg-white"}`}
            bodyStyle={{ padding: 0 }}
          >
            <div
              className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
              style={{
                "--ag-header-background-color": color.themeConfig.colorPrimary,
                "--ag-header-foreground-color": "#fff",
                "--ag-header-group-bg": color.themeConfig.colorPrimaryShade, // custom var
                height: "80vh",
                width: "100%",
                overflowY: "auto",
              }}
            >
              <AgGridReact
                rowData={parameterMetersValue}
                columnDefs={deviceCols}
                domLayout="normal"
                rowHeight={50}
              />
            </div>
          </Card>
          {/* )} */}
        </div>
      </div>

      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form1}
            name="Group-add-form"
            // className="font-bold"
            layout="horizontal"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 8,
              offset: 0,
            }}
            labelAlign="left"
            onFinish={onFinish1}
          >
            <Form.Item
              // label="Converter Name"
              name="converterID"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Converter Name
                </span>
              }
              rules={[
                {
                  required: true,
                  message: "Please select a converter!",
                },
              ]}
            >
              <Select
                // value={selectedValue}
                onChange={handleConverter}
                // style={{ width: 200 }}
                labelInValue
                placeholder="Select a group"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {groupData.map((i) => (
                  <Option key={i.siteID} value={i.siteName}>
                    {i.siteName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              // label="Meter Name"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  MeterName
                </span>
              }
              name="meterID"
              rules={[
                {
                  required: true,
                  message: "Please select a meter!",
                },
              ]}
            >
              <Select
                // value={selectedValue}
                // onChange={handleChange}
                // style={{ width: 200 }}
                labelInValue
                placeholder="Select a meter"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {metersData.map((i) => (
                  <Option key={i.meterid} value={i.metername}>
                    {i.metername}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose} className="">
              Cancel
            </Button>
            <Button type="primary" onClick={() => form1.submit()}>
              Add
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>

      <CustomThemeDrawer
        title="Close"
        showDrawer={showDrawer2}
        open={open2}
        onClose={onClose2}
      >
        <div className="flex flex-col gap-6 mt-2">
          <Form
            form={form2}
            name="add-Group-Config"
            layout="horizontal"
            style={{
              maxWidth: 600,
            }}
            labelCol={{
              span: 9,
            }}
            labelAlign="left"
            onFinish={onFinish2}
            className="p-3"
          >
            {/* Group Name */}
            <Form.Item
              // label="Meter Name"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Meter Name
                </span>
              }
              name="meterID"
              rules={[
                {
                  required: true,
                  message: "Please select a converter!",
                },
              ]}
            >
              <Select
               disabled={isUpdate}
                value={selectedConverter}
                onChange={handleConverterChange}
                // style={{ width: 200 }}
                // labelInValue
                placeholder="Select a converter"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {mainDashboardData.map((i) => (
                  <Option key={i.meterID} value={i.meterID}>
                    {i.meterName}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              // label="Parameter Name"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Parameter Name
                </span>
              }
              name="parameterID"
              rules={[
                {
                  required: true,
                  message: "Please select a Parameter!",
                },
              ]}
            >
              <Select
                // value={selectedValue}
                // onChange={handleChange}
                // style={{ width: 200 }}
                // labelInValue
                disabled={isUpdate}
                placeholder="Select a parameter"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {parameter.map((i) => (
                  <Option key={i.parameterid} value={i.parameterid}>
                    {i.parametername}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              // label="Title"
               label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Title
                </span>
              }
              name="parameterHeading"
              rules={[{ required: true, message: "Please enter title!" }]}
            >
              <Input
               className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
                placeholder="Enter the title"
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>
            <Form.Item
              // label="Data Type"
               label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Data Type
                </span>
              }
              name="parameterDataType"
              rules={[{ required: true, message: "Please select a datatype!" }]}
            >
              <Select
                // value={selectedValue}
                // onChange={handleChange}
                // style={{ width: 200 }}
                // labelInValue
                placeholder="Select a parameter"
                dropdownClassName={
                  isdarkMode
                    ? "select-dropdown-background"
                    : "light-mode-dropdown"
                }
                className={`  ${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"} w-80 `}
              >
                {dataType.map((i) => (
                  <Option key={i.parameterId} value={i.parameterId}>
                    {i.parameterDataType}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Sub Group */}
            <Form.Item
              // label="Target Value"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Target Value
                </span>
              }
              name="targetValue"
              rules={[
                { required: true, message: "Please select Target Value!" },
              ]}
            >
              <InputNumber
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
                placeholder="Enter  target value"
                style={{
                  width: "100%",
                }}
              />
            </Form.Item>

            {/* Converter */}
            <Form.Item
              // label="Low Threshold Value"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  Low Threshold Value
                </span>
              }
              name="lowThresholdValue"
              rules={[
                {
                  required: true,
                  message: "Please select Low Threshold Value!",
                },
              ]}
            >
              <InputNumber
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
                style={{
                  width: "100%",
                }}
                placeholder="Enter Low Threshold value"
              />
            </Form.Item>

            {/* Consumption */}
            <Form.Item
              // label="High Threshold Value"
              label={
                <span className={isdarkMode ? "text-white" : "text-black"}>
                  High Threshold Value
                </span>
              }
              name="highThresholdValue"
              rules={[
                {
                  required: true,
                  message: "Please select High Threshold Value!",
                },
              ]}
            >
              <InputNumber
                className={
                  isdarkMode ? "dark-input-number" : "light-input-number"
                }
                style={{
                  width: "100%",
                }}
                placeholder="Enter High Threshold Value"
              />
            </Form.Item>
          </Form>

          <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
            <Button onClick={onClose2} className="">
              Cancel
            </Button>
            <Button type="primary" onClick={() => form2.submit()}>
              {isUpdate ? "Update" : "Add"}
            </Button>
          </div>
        </div>
      </CustomThemeDrawer>
    </div>
  );
};

export default DashLive;
